import { billAmountContent } from '@/content/billAmountContent';
import { BillAmountEntry, BillAmountProvider } from '@/state/state.types';
import { formatCurrencyOnBlur, parseCurrency } from '@/utils/formatCurrency';
import { BillAmountRow, isProviderDuplicate } from '@/utils/billAmountForm.utils';

export const validateRowField = (
  row: BillAmountRow,
  field: 'amount' | 'provider',
): BillAmountRow => {
  const errors = { ...row.errors };
  let amountDisplay = row.amountDisplay;
  if (field === 'amount') {
    amountDisplay = formatCurrencyOnBlur(row.amountDisplay);
    if (amountDisplay && parseCurrency(amountDisplay) <= 0) {
      errors.amount = billAmountContent.errors.amountPositive;
    } else {
      errors.amount = undefined;
    }
  }
  if (field === 'provider') {
    if (row.amount > 0 && !row.provider) {
      errors.provider = billAmountContent.errors.providerRequired;
    } else {
      errors.provider = undefined;
    }
  }
  return { ...row, amountDisplay, errors };
};

export const validateAllRows = (
  rows: BillAmountRow[],
): { rows: BillAmountRow[]; isValid: boolean } => {
  let isValid = true;
  const hasCompleteRow = rows.some((row) => row.amount > 0 && row.provider !== null);

  if (!hasCompleteRow) isValid = false;

  const validated = rows.map((row) => {
    const errors = { ...row.errors };
    const isPartiallyFilled = row.amount > 0 || row.provider !== null;

    if (isPartiallyFilled || (!hasCompleteRow && row === rows[0])) {
      if (row.amount <= 0) {
        errors.amount = billAmountContent.errors.amountRequired;
        isValid = false;
      }
      if (!row.provider) {
        errors.provider = billAmountContent.errors.providerRequired;
        isValid = false;
      }
    }

    if (row.provider && isProviderDuplicate(rows, row.key, row.provider)) {
      errors.provider = billAmountContent.errors.providerDuplicate;
      isValid = false;
    }

    return { ...row, errors };
  });

  return { rows: validated, isValid };
};

export const buildFormData = (stepId: string, rows: BillAmountRow[]): FormData => {
  const entries: BillAmountEntry[] = rows
    .filter((row) => row.amount > 0 && row.provider !== null)
    .map((row) => ({
      amt: row.amount,
      provider: row.provider as BillAmountProvider,
    }));
  const formData = new FormData();
  formData.append('stepId', stepId);
  formData.append('answer', JSON.stringify(entries));
  return formData;
};
